import React, {useCallback} from 'react';
import {setIsPlayingMix} from 'actions/index.js';
import { connect } from "react-redux";
import ipfs from 'decentralized/Ipfs.js';
import Row from './Row.js';
import Modals from 'components/v2/Modals.js';
import Playhead from './Playhead.js';
import {useSequencer} from 'components/v2/useSequencer.js';
import '../../Exhibit.scss';

const ExhibitViewer = ({sequencerEngine, wallpaper}) => {
    return (
        <div
          className="exhibit">
          {sequencerEngine ? <Playhead sequencerEngine={sequencerEngine}/> : ''}
          <Row sequencerEngine={sequencerEngine} row={0}/>
          <Row sequencerEngine={sequencerEngine} row={1}/>
          <Row sequencerEngine={sequencerEngine} row={2}/>
          <Row sequencerEngine={sequencerEngine} row={3}/>
          <Row sequencerEngine={sequencerEngine} row={4}/>
          <Row sequencerEngine={sequencerEngine} row={5}/>
       </div>
    );
};

const mapStateToProps = (state, props) => {
    return {
        wallpaper: state.sequencer.wallpaper,
    };
};

const mapDispatchToProps = (dispatch) => ({
    setIsPlayingMix: (p) => dispatch(setIsPlayingMix(p))
});
 
export default connect(mapStateToProps, mapDispatchToProps)(ExhibitViewer);



